import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import {
  selectIsChatAiLoading,
  setChatAiIsOpenActionCreator,
  setThreadChatMessageEmptyActionCreator,
} from '~/redux/slices/chat-ai'
import { OracleTurnEnding } from '~/aioracle/types/oracle-ending.types'

import useOracleMessage from './useOracleMessage'
interface SendToOracleAIOptions {
  isCurriculum: boolean
}
export default function useOraclePrompt(): (
  title: string,
  value: string,
  isCurriculum?: SendToOracleAIOptions,
  curriculumLevelId?: string,
  isCompleted?: boolean,
  doNotShowModal?: boolean,
) => Promise<OracleTurnEnding | null> {
  const dispatch = useAppDispatch()
  const { onSendMessageClick } = useOracleMessage()
  const isLoading = useAppSelector(selectIsChatAiLoading)

  const sendToOracleAI = (
    title: string,
    value: string,
    { isCurriculum = false }: SendToOracleAIOptions,
    curriculumLevelId?: string,
    isCompleted?: boolean,
    doNotShowModal = false,
  ): Promise<OracleTurnEnding | null> => {
    if (!isLoading && value && value.length > 0) {
      dispatch(setThreadChatMessageEmptyActionCreator())

      if (!doNotShowModal) dispatch(setChatAiIsOpenActionCreator(true))

      return onSendMessageClick(value, title, undefined, isCurriculum, curriculumLevelId, isCompleted)
    }
    return Promise.resolve(null)
  }

  return sendToOracleAI
}
